import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  ChangePasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  ResetPasswordRequest,
  ResetPasswordValidationResponse,
} from '../../../core/models/auth.model';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/auth`;

  login(credentials: LoginRequest) {
    return this.http.post<LoginResponse>(this.apiUrl, credentials);
  }

  // Called without Authorization: authInterceptor leaves /auth/refresh untouched.
  refresh(refreshToken: string) {
    return this.http.post<LoginResponse>(`${this.apiUrl}/refresh`, { refreshToken });
  }

  forgotPassword(email: string) {
    return this.http.post<ForgotPasswordResponse>(`${this.apiUrl}/forgot-password`, { email });
  }

  validateResetPasswordCode(email: string, code: string) {
    return this.http.get<ResetPasswordValidationResponse>(
      `${this.apiUrl}/reset-password/validate`,
      {
        params: { email, code },
      },
    );
  }

  resetPassword(data: ResetPasswordRequest) {
    return this.http.post<void>(`${this.apiUrl}/reset-password`, data);
  }

  getProfile(token: string) {
    return this.http.get<unknown>(`${environment.apiUrl}/user/profile`, {
      headers: new HttpHeaders({ Authorization: `Bearer ${token}` }),
    });
  }

  changePassword(data: ChangePasswordRequest) {
    return this.http.patch<void>(`${this.apiUrl}/change-password`, data);
  }
}
